import { NavLink, Navigate, Route, Routes } from 'react-router-dom'

import { Glass, useSession } from './lib/session'
import Ask from './screens/Ask'
import Capture from './screens/Capture'
import Cellar from './screens/Cellar'
import Family from './screens/Family'
import History from './screens/History'
import Results from './screens/Results'
import ScanProgress from './screens/ScanProgress'
import WineDetail from './screens/WineDetail'

export default function App() {
  const { user, signIn } = useSession()

  if (!user) return <SignIn onSignIn={signIn} />

  return (
    <div className="mx-auto flex min-h-dvh w-full max-w-2xl flex-col">
      <Header />
      <main className="flex-1 px-4 pb-28">
        <Routes>
          <Route path="/" element={<Capture />} />
          <Route path="/scan/:runId" element={<ScanProgress />} />
          <Route path="/scan/:runId/results" element={<Results />} />
          <Route path="/cellar" element={<Cellar />} />
          <Route path="/ask" element={<Ask />} />
          <Route path="/history" element={<History />} />
          <Route path="/family" element={<Family />} />
          <Route path="/wine/:wineId" element={<WineDetail />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <TabBar />
    </div>
  )
}

function Header() {
  const { user, signOutNow } = useSession()
  return (
    <header className="sticky top-0 z-20 flex items-center gap-3 border-b border-white/5 bg-cellar-900/80 px-4 py-3 backdrop-blur">
      <Glass className="h-6 w-6 text-wine-300" />
      <span className="font-display text-lg tracking-wide">Wranker AI</span>
      <NavLink
        to="/family"
        className="ml-auto text-xs text-stone-500 hover:text-stone-300"
      >
        Family
      </NavLink>
      <button
        className="text-xs text-stone-500 hover:text-stone-300"
        onClick={() => void signOutNow()}
      >
        {user?.displayName?.split(' ')[0] ?? 'Sign out'} · out
      </button>
    </header>
  )
}

function TabBar() {
  const tab = ({ isActive }: { isActive: boolean }) =>
    `flex-1 rounded-full px-4 py-2.5 text-center text-sm transition ${
      isActive ? 'bg-wine-700 text-white' : 'text-stone-400 hover:text-stone-200'
    }`
  return (
    <nav className="fixed inset-x-0 bottom-0 z-20 mx-auto w-full max-w-2xl px-4 pb-[max(1rem,env(safe-area-inset-bottom))]">
      <div className="card flex gap-1 p-1.5">
        <NavLink to="/" className={tab} end>
          Scan
        </NavLink>
        <NavLink to="/cellar" className={tab}>
          Cellar
        </NavLink>
        <NavLink to="/ask" className={tab}>
          Ask
        </NavLink>
        <NavLink to="/history" className={tab}>
          History
        </NavLink>
      </div>
    </nav>
  )
}

function SignIn({ onSignIn }: { onSignIn: () => Promise<void> }) {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 px-8 text-center">
      <Glass className="h-16 w-16 text-wine-300" />
      <div>
        <h1 className="font-display text-3xl">Wranker AI</h1>
        <p className="mt-2 max-w-xs text-sm text-stone-400">
          Photograph a shelf. Four sommeliers argue about it. You get an ordered list and
          something to cook.
        </p>
      </div>
      <button className="btn-primary" onClick={() => void onSignIn()}>
        Continue with Google
      </button>
    </div>
  )
}
